import { Component, Output, EventEmitter, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToasterService } from '../../../../services/toaster/toaster.service';

@Component({
  selector: 'app-edit-email',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './edit-email.html',
})
export class EditEmail {
  private toaster = inject(ToasterService);

  @Output() cancel = new EventEmitter<void>();

  currentPassword = signal('');
  newEmail = signal('');

  onSubmit() {
    if (!this.currentPassword() || !this.newEmail()) {
      this.toaster.warning('Please fill in all fields.');
      return;
    }
    // Mock successful update
    this.toaster.success('Email updated successfully!');
    this.cancel.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
